import { render, staticRenderFns } from "./GaofangDetail.vue?vue&type=template&id=94640828&scoped=true"
import script from "./GaofangDetail.vue?vue&type=script&lang=js"
export * from "./GaofangDetail.vue?vue&type=script&lang=js"
import style0 from "./GaofangDetail.vue?vue&type=style&index=0&id=94640828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94640828",
  null
  
)

export default component.exports